import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import componentReducer from '~reducers/component_reducers';
import notificationReducer from '~reducers/notification_reducers';

export const reducers = combineReducers({
  component: componentReducer,
  notification: notificationReducer,
});

export function configureStore(initialState = {}) {
  return createStore(reducers, initialState, applyMiddleware(promise, thunk));
}

export const store = configureStore();
window.store = store;
